module.exports = __webpack_public_path__ + "media/images/icon-teacher-e7e356823396f98d4d6b3ea5a68ed9ea.png";